import { render, staticRenderFns } from "./LessonEntityDetails.vue?vue&type=template&id=666d8907"
import script from "./LessonEntityDetails.vue?vue&type=script&lang=js"
export * from "./LessonEntityDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('666d8907')) {
      api.createRecord('666d8907', component.options)
    } else {
      api.reload('666d8907', component.options)
    }
    module.hot.accept("./LessonEntityDetails.vue?vue&type=template&id=666d8907", function () {
      api.rerender('666d8907', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LessonEntityDetails.vue"
export default component.exports